import { createReducer, AnyAction } from '@reduxjs/toolkit';
import * as commonEnums from '../../../enums/index';
import * as uiActions from '../../../actions/ui.actions';
import * as launchPageActions from '../../../actions/launch-page.action';
import { epicToken } from '../../../actions/launch-page.action';
import { ampUI } from '../state/amp-ui';
import { resetCommonState } from '../../../actions/ui.actions';
import { getCoderConfig } from '../actions/coder-config';

const { embeddedLaunch, standaloneLaunch, contextParams } = launchPageActions;
const {
  dismissConfirm,
  handleConfirm,
  showConfirm,
  amplifyFeedback,
  hideFeedback,
  setStandaloneMode,
  setAmplifyView,
  setAutomateView
} = uiActions;

const ui = createReducer(ampUI, builder => {
  builder.addCase(resetCommonState.type, () => ({ ...ampUI }));

  builder.addCase(dismissConfirm.type, state => {
    return {
      ...state,
      confirm: {
        display: false,
        title: 'Remove Charge'
      }
    };
  });

  builder.addCase(handleConfirm.type, state => {
    return {
      ...state,
      confirm: {
        display: false,
        title: 'Remove Charge'
      }
    };
  });

  builder.addCase(contextParams.type, (state, action: AnyAction) => {
    return { ...state, contextParams: action.payload };
  });

  builder.addCase(epicToken.type, (state, action: AnyAction) => {
    return { ...state, epicToken: action.payload };
  });

  builder.addCase(showConfirm.type, (state, action: AnyAction) => {
    const actionItem = action.payload;
    return {
      ...state,
      confirm: {
        display: true,
        title: 'Remove Charge',
        helpText: 'Removing this charge will delete this procedure.',
        actionItem
      }
    };
  });

  builder.addCase(amplifyFeedback.type, (state, action: AnyAction) => {
    const payload = action.payload;
    return {
      ...state,
      showFeedBack: true,
      feedback: {
        message: payload.message,
        dismissable: payload.dismissable,
        id: Date.now(),
        meta: {
          level: payload.meta
        }
      }
    };
  });

  builder.addCase(hideFeedback.type, state => {
    return {
      ...state,
      showFeedBack: false
    };
  });

  builder.addCase(embeddedLaunch.pending, state => {
    return {
      ...state,
      UIMode: commonEnums.UIModesEnum.EPIC_EMBEDDED
    };
  });

  builder.addCase(standaloneLaunch.pending, state => {
    return {
      ...state,
      UIMode: commonEnums.UIModesEnum.STANDALONE
    };
  });

  builder.addCase(setStandaloneMode.type, state => {
    return {
      ...state,
      UIMode: commonEnums.UIModesEnum.STANDALONE
    };
  });

  builder.addCase(setAmplifyView.type, state => {
    return {
      ...state,
      UIView: commonEnums.UIViewEnum.AMPLIFY
    };
  });

  builder.addCase(setAutomateView.type, state => {
    return {
      ...state,
      UIView: commonEnums.UIViewEnum.AUTOMATE
    };
  });

  builder.addCase(getCoderConfig.pending, state => {
    return {
      ...state,
      coderConfig: []
    };
  });

  builder.addCase(getCoderConfig.rejected, state => {
    return {
      ...state,
      coderConfig: []
    };
  });

  builder.addCase(getCoderConfig.fulfilled, (state, action) => {
    return {
      ...state,
      coderConfig: action.payload
    };
  });
});

export { ui as ampUI };
